import { ReactElement, memo, useState } from 'react';
import { Button, ButtonProps, useNotify, useRefresh, useRecordContext, useListContext, useResourceContext, HttpError, Confirm } from 'react-admin';
import fetchJson from 'utils/fetchJson';
import { fetchUtils } from 'react-admin';

export interface FetchButtonProps extends ButtonProps {
  urlSlug: string,
  options: fetchUtils.Options,
  doRefresh?: boolean,
  onSuccess?: (json: any) => void,
  onError?: (e: HttpError) => void,
  // startIcon?: ReactElement,
  confirmTitle?: string,
  confirmContent?: string,
}

const FetchButton = (props: FetchButtonProps) => {
  const { urlSlug, options, doRefresh, onSuccess, onError ,confirmTitle, confirmContent, ...rest } = props;
  const resource = useResourceContext();
  const record = useRecordContext();
  const refresh = useRefresh()
  const { selectedIds } = useListContext();
  const notify = useNotify();
  const [open, setOpen] = useState(false);

  const onClick = () => {
    if (confirmTitle || confirmContent) {
      setOpen(true);
    } else {
      doFetch();
    }
  }

  const doFetch = () => {
    let ids = null;
    if (undefined !== record) {
      ids = `${record.id}`;
    } else if (0 < selectedIds.length) {
      // console.log('Do bulk');
      ids = selectedIds.join(',');
    }

    if (null !== ids) {
      return fetchJson(`/api/${props.urlSlug}/${process.env.REACT_APP_API_TABLE_PREFIX}${resource}/${ids}`, options)
        .then((json: any) => {
          onSuccess && onSuccess(json);
          // console.log(1234, json);
          if (doRefresh) {
            refresh();
          }
          return 2;
        })
        .catch((e: HttpError) => {
          // console.log('40', typeof e.body, e.body.message);
          notify(`${e.body.message}`, { type: 'error' });
          onError && onError(e);
          return 1;
        })
        .finally(() => {
          console.log('finally 1234');
        })
        ;
    } else {
      return Promise.resolve();
    }
  }

  const handleConfirm = () => {
    doFetch().then(() => {
      setOpen(false);
    });
  }

  const handleDialogClose = () => {
    setOpen(false);
  }


  return (<>
    <Button onClick={onClick} {...rest} />

    <Confirm
      isOpen={open}
      // loading={isLoading}
      title={confirmTitle}
      content={confirmContent}
      onConfirm={handleConfirm}
      onClose={handleDialogClose}
    />
  </>)
}

FetchButton.defaultProps = {
  doRefresh: false,
  confirmTitle: '',
  confirmContent: '',
}

export default memo(FetchButton);
